// Author : Vishnu
// Version :0.0.1
// MODIFIED DATE: 21/08/2025
import BalanceSheetType from './balance-sheet.types';

/** ***************** GET PROFIT LOSS REPORT START *********************** */
export const getProfitLossReportStart = (getData: any) => ({
	type: BalanceSheetType.GET_PROFIT_LOSS_REPORT_START,
	payload: getData,
});

export const getProfitLossReportSuccess = (successData: any) => ({
	type: BalanceSheetType.GET_PROFIT_LOSS_REPORT_SUCCESS,
	payload: successData,
});

export const getProfitLossReportFailure = (failureData: any) => ({
	type: BalanceSheetType.GET_PROFIT_LOSS_REPORT_FAILURE,
	payload: failureData,
});

export const getProfitLossReportResponseResetStart = () => ({
	type: BalanceSheetType.GET_PROFIT_LOSS_REPORT_RESPONSE_RESET,
});

export const getProfitLossReportResponseChanged = () => ({
	type: BalanceSheetType.GET_PROFIT_LOSS_REPORT_RESPONSE_CHANGED,
});
/** ***************** GET BPROFIT LOSS REPORT END *********************** */

/** ***************** GET BALANCE SHEET REPORT START *********************** */
export const getBalanceSheetReportStart = (getData: any) => ({
	type: BalanceSheetType.GET_BALANCE_SHEET_REPORT_START,
	payload: getData,
});

export const getBalanceSheetReportSuccess = (successData: any) => ({
	type: BalanceSheetType.GET_BALANCE_SHEET_REPORT_SUCCESS,
	payload: successData,
});

export const getBalanceSheetReportFailure = (failureData: any) => ({
	type: BalanceSheetType.GET_BALANCE_SHEET_REPORT_FAILURE,
	payload: failureData,
});

export const getBalanceSheetReportResponseResetStart = () => ({
	type: BalanceSheetType.GET_BALANCE_SHEET_REPORT_RESPONSE_RESET,
});

export const getBalanceSheetReportResponseChanged = () => ({
	type: BalanceSheetType.GET_BALANCE_SHEET_REPORT_RESPONSE_CHANGED,
});
/** *****************GET BALANCE SHEET REPORT  END *********************** */
